/* ===========================
   EXOTICZ CLOTHING -- THEME JS
   =========================== */

document.addEventListener('DOMContentLoaded', () => {

  // CART DRAWER
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartCloseBtn = document.querySelector('[data-cart-close]');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('active');
    document.documentElement.style.overflow = '';
  }

  // iOS FIX: body overflow:hidden kills all touchmove globally on iOS Safari.
  // Intercept touchmove on the cart items container so iOS lets it scroll.
  const cartItemsEl = document.querySelector('.cart-drawer__items');
  if (cartItemsEl) {
    let _touchStartY = 0;
    cartItemsEl.addEventListener('touchstart', function(e) {
      _touchStartY = e.touches[0].clientY;
    }, { passive: true });

    cartItemsEl.addEventListener('touchmove', function(e) {
      const deltaY = e.touches[0].clientY - _touchStartY;
      const atTop = this.scrollTop === 0;
      const atBottom = this.scrollTop + this.clientHeight >= this.scrollHeight;
      // At scroll boundaries, block so the page behind doesn't move
      if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
        e.preventDefault();
      } else {
        // Otherwise stop the event from reaching the locked body
        e.stopPropagation();
      }
    }, { passive: false });
  }

  cartToggleBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartCloseBtn?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // ADD TO CART — with size validation
  const addToCartForm = document.querySelector('[data-add-to-cart-form]');
  addToCartForm?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = addToCartForm.querySelector('[data-add-to-cart-btn]');
    const sizeError = document.getElementById('size-error');

    // Validate size selection if product has variants
    if (btn?.dataset.requiresVariant === 'true') {
      const activeSize = addToCartForm.querySelector('.size-btn.active');
      if (!activeSize) {
        if (sizeError) {
          sizeError.style.display = 'block';
          sizeError.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        // Shake the size grid
        const sizeGrid = addToCartForm.querySelector('.size-grid');
        if (sizeGrid) {
          sizeGrid.classList.add('size-shake');
          setTimeout(() => sizeGrid.classList.remove('size-shake'), 600);
        }
        return;
      }
    }

    if (sizeError) sizeError.style.display = 'none';

    const formData = new FormData(addToCartForm);
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (res.ok) {
        btn.textContent = '✓ Added!';
        setTimeout(() => {
          btn.textContent = 'ADD TO CART →';
          btn.disabled = false;
        }, 1500);
        await refreshCart();
        openCart();
      } else {
        const err = await res.json();
        btn.textContent = err.description || 'Try Again';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = 'ADD TO CART →'; }, 2000);
      }
    } catch (err) {
      console.error(err);
      btn.textContent = 'ADD TO CART →';
      btn.disabled = false;
    }
  });

  // Clear size error when a size is picked
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const sizeError = document.getElementById('size-error');
      if (sizeError) sizeError.style.display = 'none';
    });
  });

  // STICKY ATC — show when main ATC button scrolls out of view
  const mainAtcBtn = document.querySelector('.add-to-cart-btn');
  const stickyAtc = document.getElementById('sticky-atc');
  if (mainAtcBtn && stickyAtc) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyAtc.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAtcBtn);
  }

  // REFRESH CART
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCount(cart.item_count);
      renderCartItems(cart);
    } catch (err) {
      console.error(err);
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function renderCartItems(cart) {
    const container = document.querySelector('.cart-drawer__items');
    const totalEl = document.querySelector('.cart-totals__amount');
    if (!container) return;

    if (cart.items.length === 0) {
      container.innerHTML = '<div class="cart-drawer__empty">YOUR CART IS EMPTY</div>';
    } else {
      container.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item__image-wrap">
            <img class="cart-item__image" src="${item.image}" alt="${item.title}">
          </div>
          <div class="cart-item__info">
            <div class="cart-item__title">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
            <div class="cart-item__price">${formatMoney(item.final_price)}</div>
            <div class="cart-item__qty">
              <button class="qty-btn" onclick="updateQty('${item.key}', ${item.quantity - 1})">-</button>
              <span class="qty-num">${item.quantity}</span>
              <button class="qty-btn" onclick="updateQty('${item.key}', ${item.quantity + 1})">+</button>
              <button class="qty-remove" onclick="updateQty('${item.key}', 0)">REMOVE</button>
            </div>
          </div>
        </div>
      `).join('');
    }

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' USD';
  }

  // SIZE SELECTOR
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('unavailable')) return;
      btn.closest('.size-grid')?.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const variantInput = document.querySelector('[name="id"]');
      if (variantInput) variantInput.value = btn.dataset.variantId;
    });
  });

  // INIT CART COUNT
  refreshCart();

});

// ── QUICK ADD (no variant / single variant) ─────────────────────────────────
window.quickAdd = async function(e, btn) {
  e.preventDefault();
  e.stopPropagation();
  const variantId = btn.dataset.variantId;
  if (!variantId) return;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (res.ok) {
      btn.textContent = '✓ Added!';
      // Refresh cart count
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
      // Open cart drawer
      const cartDrawer = document.getElementById('cart-drawer');
      const cartOverlay = document.getElementById('cart-overlay');
      cartDrawer?.classList.add('open');
      cartOverlay?.classList.add('active');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(() => { btn.textContent = 'QUICK ADD →'; btn.disabled = false; }, 2000);
    } else {
      btn.textContent = 'QUICK ADD →'; btn.disabled = false;
    }
  } catch (err) {
    btn.textContent = 'QUICK ADD →'; btn.disabled = false;
  }
};

// ── QUICK ADD MODAL (multi-variant) ─────────────────────────────────────────
window.openQuickAddModal = function(e, productUrl, title, imgSrc, variants, price) {
  e.preventDefault();
  e.stopPropagation();

  // Remove existing modal
  document.getElementById('qa-modal')?.remove();

  const available = variants.filter(v => v.available);
  const modal = document.createElement('div');
  modal.id = 'qa-modal';
  modal.innerHTML = `
    <div class="qa-modal__backdrop" onclick="document.getElementById('qa-modal').remove(); document.documentElement.style.overflow=''"></div>
    <div class="qa-modal__box">
      <button class="qa-modal__close" onclick="document.getElementById('qa-modal').remove(); document.documentElement.style.overflow=''">✕</button>
      <div class="qa-modal__inner">
        <img class="qa-modal__img" src="${imgSrc}" alt="${title}">
        <div class="qa-modal__info">
          <div class="qa-modal__title">${title}</div>
          <div class="qa-modal__price">$${(price/100).toFixed(2)}</div>
          <div class="qa-modal__label">SELECT SIZE</div>
          <div class="qa-modal__sizes">
            ${variants.map(v => `
              <button
                class="qa-size-btn${v.available ? '' : ' unavailable'}"
                data-variant-id="${v.id}"
                ${!v.available ? 'disabled' : ''}
                onclick="qaSelectSize(this)"
              >${v.title}</button>
            `).join('')}
          </div>
          <div class="qa-modal__error" id="qa-error" style="display:none">⚠ Please select a size</div>
          <button class="qa-modal__atc" id="qa-atc-btn" onclick="qaAddToCart()">ADD TO CART →</button>
          <a href="${productUrl}" class="qa-modal__view">View Full Details</a>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);
  document.documentElement.style.overflow = 'hidden';
  requestAnimationFrame(() => modal.querySelector('.qa-modal__box').classList.add('open'));
};

window.qaSelectSize = function(btn) {
  if (btn.classList.contains('unavailable')) return;
  document.querySelectorAll('.qa-size-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById('qa-error').style.display = 'none';
};

window.qaAddToCart = async function() {
  const active = document.querySelector('.qa-size-btn.active');
  if (!active) {
    document.getElementById('qa-error').style.display = 'block';
    return;
  }
  const btn = document.getElementById('qa-atc-btn');
  btn.textContent = 'Adding...';
  btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: active.dataset.variantId, quantity: 1 })
    });
    if (res.ok) {
      document.getElementById('qa-modal').remove();
      document.documentElement.style.overflow = '';
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
      const cartDrawer = document.getElementById('cart-drawer');
      const cartOverlay = document.getElementById('cart-overlay');
      cartDrawer?.classList.add('open');
      cartOverlay?.classList.add('active');
      document.documentElement.style.overflow = 'hidden';
    } else {
      btn.textContent = 'ADD TO CART →'; btn.disabled = false;
    }
  } catch(err) {
    btn.textContent = 'ADD TO CART →'; btn.disabled = false;
  }
};

// Global updateQty
window.updateQty = function(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(res) { return res.json(); })
  .then(function() { window.location.reload(); })
  .catch(function(err) { console.error('Cart update failed:', err); });
};
